import { audioPlayer } from "../../components/AssetLibrary";

/*
 * Copyright (C) Ivo Ladage-van Doorn - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Ivo Ladage-van Doorn <ivol37@gmail.com>, 2024
 */
function DoortrappersMuziek() {
  return (
    <div>
      <div className="box light">
        <div className="row">
          <h1>Doortrappers en AI</h1>
          <p>Met behulp van AI is deze prachtige songlist tot stand gekomen, als ondersteuning van onze barre tocht van Eindhoven naar Érezée.</p>
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>De Doortrappers - Doortrap-per-pers</h2>
          {audioPlayer(1, "doortrappers/De Doortrappers - Doortrap-per-pers.mp3")}
          <br />
          [Verse]
          <br />
          Daar gaan ze, vanuit Eindhoven
          <br />
          Met hun fietsen, klaar voor de reis
          <br />
          De Doortrappers, op pad naar België
          <br />
          Vol energie en avontuurlijkheid
          <br />
          <br />
        </div>
        <div className="right">
          [Verse 2]
          <br />
          De weg is lang, de weg is zwaar
          <br />
          Maar ze gaan door, met een lach op hun gezicht
          <br />
          Samen trappen ze, als een hechte groep
          <br />
          Als Doortrappers, geven ze het beste van zichzelf
          <br />
          <br />
          [Chorus]
          <br />
          Doortrappers, met echte doorzettingskracht
          <br />
          Fietsend van Eindhoven naar Érezée
          <br />
          Met elke kilometer, komen ze dichterbij
          <br />
          Doortrappers, een team dat nooit opgeeft
          <br />
        </div>
      </div>
      <div className="box light">
        <div className="left">
          <h2>De Doortrappers - Doortrappers door de nacht</h2>
          {audioPlayer(2, "doortrappers/De Doortrappers - Doortrappers door de nacht.mp3")}
          <p>
            <br />
            [Verse]
            <br />
            Pantalonmeister in z'n kleurrijke broeken,
            <br />
            Kilometers trappen, nooit opgeven of vloeken,
            <br />
            Atarimeister gamen in de pauze, geen paniek,
            <br />
            Frietmeister snakt naar mayo, smaken uniek.
            <br />
            <br />
            [Verse 2]
            <br />
            Fahrradführer leidt ons, altijd voorop,
            <br />
            Door de storm en regen, niemand stopt,
            <br />
            Schwitzi zweet peentjes, nat tot op z’n sokken,
            <br />
            Dat Oud Klooster, tijd om op krachten te komen.
            <br /> <br />
            [Chorus]
            <br />
            Doortrappers door de nacht, we fietsen maar door,
            <br />
            Lekke banden, stortbuien, geen tijd of spoor,
            <br />
            Chateau Nucleaire wacht, mysterieus en vreemd,
            <br />
            Samen naar Érezée, dat is waar de droom leeft.
            <br />
            <br />
          </p>
        </div>

        <div className="right">
          [Verse 3]
          <br />
          Schwitzende zolen door modderpaden worstelen,
          <br />
          Pantalonmeister's pedaal breekt, geen knutselen,
          <br />
          Atarimeister vecht met z'n virtuele draken,
          <br />
          Maar de weg is echt, geen tijd om te verzaken.
          <br />
          <br />
          [Bridge]
          <br />
          Hartslag omhoog, regen klettert op ons neer,
          <br />
          Fahrradführer leidt de weg, geen angst of bekeer,
          <br />
          De frieten onderweg, Frietmeister eet z'n deel,
          <br />
          Schwitzi druipt, maar blijft groots in elke scheel.
          <br />
          <br />
          [Chorus]
          <br />
          Doortrappers door de nacht, we fietsen maar door,
          <br />
          Lekke banden, stortbuien, geen tijd of spoor,
          <br />
          Chateau Nucleaire wacht, mysterieus en vreemd,
          <br />
          Samen naar Érezée, dat is waar de droom leeft.
          <br />
        </div>
      </div>
      <div className="box main">
        <div className="row">
          <h2>De Doortrappers - Een hecht team</h2>
          {audioPlayer(3, "doortrappers/De Doortrappers - Een hecht team.mp3")}

          <p>
            Een hecht team genaamd "de Doortrappers" gaat 400 kilometer fietsen in de Belgische Ardennen. Iedere fietsen heeft een bijnaam. Zo hebben we: de Fahrradführer die de
            routes uitzet. De Atarimeister die reserveonderdelen bij zich heeft. De Pantalonmeister die in zijn nette broek met vouw altijd probeert een omweg te vinden. De
            Frietmeister die zich altijd ziek probeert te eten aan friet. En tot slot de Schwitzmeister, ook wel Schwitzi genoemd, die zijn zweet uitstort op zijn achtervolgers.
          </p>
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>De Doortrappers - Het is geen team, het zijn broeders</h2>
          {audioPlayer(4, "doortrappers/De Doortrappers - Het is geen team, het zijn broeders.mp3")}
          <br />
          [Verse]
          <br />
          De Doortrappers' squad, 400 clicks gaan rollen
          <br />
          De Fahrradführer, routes scherp uitgestippeld
          <br />
          GPS in de hand, bergen beklimmen, dalen
          <br />
          Met Schwitzi die zweet, natte druppels in zijn ballen
          <br />
          <br />
          [Verse 2]
          <br />
          Atarimeister klaar, tools stevig vast in zak
          <br />
          Metalen vriend, als er iets breekt, repareer binnen het tak
          <br />
          Schroeven draaiend, ketting spannen, altijd berekend
          <br />
          Verbetert fietsen rap, noem hem de mecanicien
          <br />
          <br />
          [Chorus]
          <br />
          Fietsen over bergen, door dalen en over keien
          <br />
          Het is geen team, het zijn broeders, je kan er niet naast kijken
          <br />
          De Doortrappers binden samen, als een wiel dat draait
          <br />
          Vrienden voor het leven, elke pedaalslag gewaardeerd
        </div>
        <div className="right">
          [Verse]
          <br />
          Pantalonmeister in zijn nette broek, altijd strak
          <br />
          Altijd op zoek naar de omweg achter elke bocht
          <br />
          Misschien vindt hij de schat verborgen achter struik
          <br />
          Met geplooide broekspijp, drukt hij door met gewicht
          <br />
          <br />
          [Verse 2]
          <br />
          Frietmeister aan de kant, eet zich klem aan patat
          <br />
          Bourgondiër van het team, maag altijd wel wat krap
          <br />
          Met mayo en ketchup, hij geniet van elk moment
          <br />
          Ondanks zijn vreetlust, nooit wordt hij echt geremd
          <br />
          <br />
          [Chorus]
          <br />
          Fietsen over bergen, door dalen en over keien
          <br />
          Het is geen team, het zijn broeders, je kan er niet naast kijken
          <br />
          De Doortrappers binden samen, als een wiel dat draait
          <br />
          Vrienden voor het leven, elke pedaalslag gewaardeerd
          <br />
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>De Doortrappers - Onze Bijnamen</h2>
          {audioPlayer(5, "doortrappers/De Doortrappers - Onze Bijnamen.mp3")}
          <br />
          [Verse]
          <br />
          Jij pikt heel snel iets op
          <br />
          Beetje hier beetje daar
          <br />
          Het lijkt wel een spel
          <br />
          <br />
          [Verse]
          <br />
          We noemen jou de snelle
          <br />
          Altijd scherp altijd snel
          <br />
          Dat is nou wie je bent
          <br />
          <br />
          [Chorus]
          <br />
          Onze bijnamen dat is wie we zijn
          <br />
          Elke dag weer nieuw elke keer fijn
          <br />
          Onze bijnamen dat is wie we zijn
          <br />
          Een leven vol plezier geen enkele lijn
        </div>
        <div className="right">
          [Bridge]
          <br />
          Samen maken we het waar
          <br />
          Lachen gieren keer op keer
          <br />
          Dat is nu hoe het gaat
          <br />
          <br />
          [Chorus]
          <br />
          Onze bijnamen dat is wie we zijn
          <br />
          Elke dag weer nieuw elke keer fijn
          <br />
          Onze bijnamen dat is wie we zijn
          <br />
          Een leven vol plezier geen enkele lijn
          <br />
          <br />
          [Verse]
          <br />
          Het zit in ons bloed
          <br />
          Speels en wild in de lucht
          <br />
          Dat maakt ons zo goed
          <br />
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>De Doortrappers - We fietsen maar door</h2>
          {audioPlayer(6, "doortrappers/De Doortrappers - We fietsen maar door.mp3")}
          <br />
          [Verse]
          <br />
          Pantalonmeister in z'n kleurrijke broeken,
          <br />
          Kilometers trappen, nooit opgeven of vloeken,
          <br />
          Atarimeister gamen in de pauze, geen paniek,
          <br />
          Frietmeister snakt naar mayo, smaken uniek.
          <br />
          <br />
          [Verse 2]
          <br />
          Fahrradführer leidt ons, altijd voorop,
          <br />
          Door de storm en regen, niemand stopt,
          <br />
          Schwitzi zweet peentjes, nat tot op z’n sokken,
          <br />
          Dat Oud Klooster, tijd om op krachten te komen.
          <br />
          <br />
          [Chorus]
          <br />
          Doortrappers door de nacht, we fietsen maar door,
          <br />
          Lekke banden, stortbuien, geen tijd of spoor,
          <br />
          Chateau Nucleaire wacht, mysterieus en vreemd,
          <br />
          Samen naar Érezée, dat is waar de droom leeft.
        </div>
        <div className="right">
          [Verse 3]
          <br />
          Schwitzende zolen door modderpaden worstelen,
          <br />
          Pantalonmeister's pedaal breekt, geen knutselen,
          <br />
          Atarimeister vecht met z'n virtuele draken,
          <br />
          Maar de weg is echt, geen tijd om te verzaken.
          <br />
          <br />
          [Bridge]
          <br />
          Hartslag omhoog, regen klettert op ons neer,
          <br />
          Fahrradführer leidt de weg, geen angst of bekeer,
          <br />
          De frieten onderweg, Frietmeister eet z'n deel,
          <br />
          Schwitzi druipt, maar blijft groots in elke scheel.
          <br />
          <br />
          [Chorus]
          <br />
          Doortrappers door de nacht, we fietsen maar door,
          <br />
          Lekke banden, stortbuien, geen tijd of spoor,
          <br />
          Chateau Nucleaire wacht, mysterieus en vreemd,
          <br />
          Samen naar Érezée, dat is waar de droom leeft.
          <br />
        </div>
      </div>

      <div className="box main">
        <div className="left">
          <h2>De Doortrappers - Zijn broek strak gespannen</h2>
          {audioPlayer(7, "doortrappers/De Doortrappers - Zijn broek strak gespannen.mp3")}
          <br />
          [Verse]
          <br />
          Fietsen die paden, van Eindhoven de start
          <br />
          Met wind in de rug, we gaan dwars door elk hart
          <br />
          Pantalonmeister leid, zijn broek strak gespannen
          <br />
          Atarimeister gamet, tot de zon weer is aan branden
          <br />
          <br />
          [Verse 2]
          <br />
          Frietmeister met een frietje, steeds handen vet
          <br />
          Fahrradführer voorop, elke heuvel zijn flat
          <br />
          Schwitzi zweet, bocht na bocht nog meer
          <br />
          Door regen en donders, door weer en verkeer
          <br />
          <br />
          [Chorus]
          <br />
          Stortbuien in ons gezicht, maar lachen blijft onverschrokken
          <br />
          Lekke banden, we gaan geen stap terug
          <br />
          Afgebroken trappers maar door, geen moment te bevriezen
          <br />
          De Doortrappers door de nacht, naar Érezée in België
        </div>
        <div className="right">
          [Verse 3]
          <br />
          Oud Klooster voor de nacht, geschiedenis in de muren
          <br />
          Dit leven als groot avontuur, zijn we aan het turen
          <br />
          Chateau Nucleaire in zicht, straling of gewoon licht
          <br />
          Zo doorgegaan tot de zon ons weer hit
          <br />
          <br />
          [Bridge]
          <br />
          Problemen onderweg, maar altijd doorgezet
          <br />
          Ivo paadjes nemen, iedereen volgt ons pad
          <br />
          Fietsen maakt ons vrij, nergens remmen op de weg
          <br />
          Kilometers onder wiel, is waarvoor we vecht
          <br />
          <br />
          [Chorus]
          <br />
          Stortbuien in ons gezicht, maar lachen blijft onverschrokken
          <br />
          Lekke banden, we gaan geen stap terug
          <br />
          Afgebroken trappers maar door, geen moment te bevriezen
          <br />
          De Doortrappers door de nacht, naar Érezée in België
          <br />
        </div>
      </div>

      <div className="box light">
        <div className="left">
          <h2>De Doortrappers - De Doortrappers, met echte doorzettingskracht</h2>
          {audioPlayer(8, "doortrappers/De Doortrappers, met echte doorzettingskracht.mp3")}
          <br />
          [Verse]
          <br />
          Daar gaan ze, vanuit Eindhoven
          <br />
          Met hun fietsen, klaar voor de reis
          <br />
          De Doortrappers, op pad naar België
          <br />
          Vol energie en avontuurlijkheid
        </div>
        <div className="right">
          [Verse 2]
          <br />
          De weg is lang, de weg is zwaar
          <br />
          Maar ze gaan door, met een lach op hun gezicht
          <br />
          Samen trappen ze, als een hechte groep
          <br />
          Als Doortrappers, geven ze het beste van zichzelf
          <br />
          <br />
          [Chorus]
          <br />
          Doortrappers, met echte doorzettingskracht
          <br />
          Fietsend van Eindhoven naar Érezée
          <br />
          Met elke kilometer, komen ze dichterbij
          <br />
          Doortrappers, een team dat nooit opgeeft
          <br />
        </div>
      </div>
    </div>
  );
}

export default DoortrappersMuziek;
